/*!
 * Built by (c) Fusion
 */
var globalScripts=function(){};export{globalScripts as g};